export default () => {
  return (
    <>
      <h1>MonitorProject</h1>
      <div>
        todo: MonitorProject scene
      </div>
    </>
  );
};
